import { document } from '~/api';
import { addAttachment } from '~/api/titleOpinion';

export const saveDocument = async (file, description, titleOpinionId, documentTypeId) => {
    try {
        const apiResponse = await document.getUploadLink(file.file);

        if (apiResponse) {
            const { uploadLink, ...uploadInfo } = apiResponse;
            file.uploadLink = uploadLink;
            file.uploadInfo = uploadInfo;
        } else {
            console.error(`Unable to get upload link for file '${file.path}'`);
        }
    
        await document.upload(file);

        const fileTypeId = documentTypeId;
        const attachment = { ...file.uploadInfo, typeId: fileTypeId, description: description };
        return await addAttachment(titleOpinionId,attachment).then((res)=>{
            //console.log(JSON.stringify(res));
            return res;
        }).catch((err) => {
            console.error(err);
        });
    }
    catch(err) {
        console.error(err);
    }
};